import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ArrowUpRightIcon } from 'lucide-react';
import { SectionLabel } from '../components/SectionLabel';
import { StatusTag } from '../components/StatusTag';
import { CTABand } from '../components/CTABand';
import { HomeHero } from '../components/HomeHero';
import { Footprint } from '../components/Footprint';
import { MissionVision } from '../components/MissionVision';
import { PropFlowPreview } from '../components/PropFlowPreview';
import { APPROACH, PRODUCTS } from '../data/site';
export function Home() {
  const [flagship, ...upcoming] = PRODUCTS;
  return <>
      <HomeHero data-id="element-297" data-mp="29fbww0yjotlv" />

      {/* Flagship product */}
      <section className="border-b border-ink-100" data-id="element-298" data-mp="2dhqfcjyaxrcm">
        <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-28" data-id="element-299" data-mp="2dja0anuwkqkq">
          <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:items-center lg:gap-20" data-id="element-300" data-mp="3ku8s5slbof1o">
            <div data-id="element-301" data-mp="3ow41nkdepyqj">
              <SectionLabel data-id="element-302" data-mp="3ovkik0c0t4ax">Live now — {flagship.category}</SectionLabel>
              <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-5xl" data-id="element-303" data-mp="30xb5hsq8cdrg">
                {flagship.name}
              </h2>
              <p className="mt-5 max-w-lg text-lg leading-relaxed text-ink-700" data-id="element-304" data-mp="2vvvoqcv34tev">
                {flagship.lede}
              </p>
              <p className="mt-4 max-w-lg text-base leading-relaxed text-ink-600" data-id="element-305" data-mp="2mxjodj4f2h98">
                Rent reminders, arrears alerts, and maintenance requests run on
                their own. You scale the portfolio without scaling the chance
                that something important gets lost in a chat thread.
              </p>
              <ul className="mt-8 space-y-2.5" data-id="element-306" data-mp="288vxvr9fgxq5">
                {flagship.points.map(point => <li key={point} className="border-l-2 border-bronze-500 pl-4 text-sm leading-relaxed text-ink-700" data-id="element-307" data-mp="23ac5p948qppc">
                    {point}
                  </li>)}
              </ul>
              <Link to="/propflow" className="group mt-9 inline-flex items-center gap-2 bg-ink-900 px-6 py-3.5 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-bronze-600" data-id="element-308" data-mp="1kk7gyw091ega">
                Inside PropFlow
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-309" data-mp="1flmgqwkzyuru" />
              </Link>
            </div>

            <PropFlowPreview data-id="element-310" data-mp="2899v3tvocp61" />
          </div>
        </div>
      </section>

      <Footprint data-id="element-311" data-mp="1tloqtwn2cjwj" />

      {/* Coming next */}
      <section className="border-b border-ink-100 bg-ink-50" data-id="element-312" data-mp="1tkvulplqdcsn">
        <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-28" data-id="element-313" data-mp="1yjyme8cp9mio">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-314" data-mp="2ma2p8di2di8m">
            <div data-id="element-315" data-mp="2m7zu5f220yx1">
              <SectionLabel data-id="element-316" data-mp="2r0sy40pp8382">Coming next</SectionLabel>
              <h2 className="mt-6 max-w-2xl text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-4xl" data-id="element-317" data-mp="2r2drvo46vi4v">
                Two more systems where records go missing
              </h2>
            </div>
            <Link to="/products" className="inline-flex items-center gap-2 text-sm font-medium text-ink-700 transition-colors duration-150 ease-out hover:text-bronze-600" data-id="element-318" data-mp="amh7lxbk1v57">
              All products
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-319" data-mp="3sru51ca1gqeh" />
            </Link>
          </div>

          <ul className="mt-12 grid gap-8 md:grid-cols-2" data-id="element-320" data-mp="3ntskemwysj0w">
            {upcoming.map(product => <li key={product.slug} className="flex h-full flex-col" data-id="element-321" data-mp="5nwfkl6gihru">
                <Link to={`/products#${product.slug}`} className="group flex h-full flex-col bg-white" data-id="element-322" data-mp="ojh13683m9f">
                  <div className="overflow-hidden bg-ink-100" data-id="element-323" data-mp="1h18ag6k8nq1v">
                    <img src={product.image} alt={`${product.name} — ${product.category}`} className="aspect-[16/9] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-324" data-mp="1c485y031evcv" />
                  </div>
                  <div className="flex flex-1 flex-col p-7" data-id="element-325" data-mp="2hb17qqlcjcfq">
                    <StatusTag status={product.status} timing={product.timing} data-id="element-326" data-mp="2mb5s4rpdkrb8" />
                    <h3 className="mt-4 flex items-start justify-between gap-4 text-2xl font-semibold tracking-tight text-ink-900" data-id="element-327" data-mp="2m92ublhzdtvy">
                      {product.name}
                      <ArrowUpRightIcon className="mt-1.5 h-5 w-5 shrink-0 text-ink-400 transition-colors duration-150 ease-out group-hover:text-bronze-600" aria-hidden="true" data-id="element-328" data-mp="2va9blwsgf8q9" />
                    </h3>
                    <p className="mt-1 text-sm text-ink-500" data-id="element-329" data-mp="3a1jafqi5rbsm">{product.category}</p>
                    <p className="mt-4 text-sm leading-relaxed text-ink-600" data-id="element-330" data-mp="3e2231mrvklvv">
                      {product.lede}
                    </p>
                  </div>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <MissionVision data-id="element-331" data-mp="yc3ck9bbokrg" />

      {/* Positioning */}
      <section className="border-b border-ink-100" data-id="element-332" data-mp="tds5g6cewocx">
        <div className="mx-auto grid max-w-container gap-10 px-6 py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20 lg:px-10 lg:py-28" data-id="element-333" data-mp="tge9vx40anqx">
          <div data-id="element-334" data-mp="1m2ple2t5i92i">
            <SectionLabel data-id="element-335" data-mp="1m38r8l5j1706">Why Keystone</SectionLabel>
            <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-ink-900 lg:text-4xl" data-id="element-336" data-mp="1m51ya1k1xt8p">
              A keystone holds the arch. So does the record nobody can afford to
              lose.
            </h2>
          </div>
          <div className="max-w-2xl" data-id="element-337" data-mp="17ekwui7f33bt">
            <p className="text-lg leading-relaxed text-ink-700" data-id="element-338" data-mp="17djl0bikuct1">
              Across the continent, enormous value moves through systems held
              together by paper files, chat threads, and the memory of one very
              busy person. Rent goes uncollected. Titles get duplicated.
              Repayments go unrecorded. The work is not missing — the record is.
            </p>
            <p className="mt-5 text-base leading-relaxed text-ink-600" data-id="element-339" data-mp="26a1xxisy9lq">
              We build the platform that holds the record and does the chasing:
              automated where the work is repetitive, auditable where the stakes
              are high, and built for mobile money and WhatsApp because that is
              what our users already use. One system per domain, monitored from
              one screen.
            </p>
            <Link to="/about" className="mt-8 inline-flex items-center gap-2 border-b border-bronze-500 pb-1 text-sm font-medium text-ink-900 transition-colors duration-150 ease-out hover:text-bronze-600" data-id="element-340" data-mp="3fjbtlszv6ouj">
              How we build
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-341" data-mp="zvbnuq2tp6na" />
            </Link>
          </div>
        </div>
      </section>

      {/* Approach */}
      <section className="border-b border-ink-100 bg-ink-950" data-id="element-342" data-mp="1ewsci24je4lw">
        <div className="mx-auto max-w-container px-6 py-20 lg:px-10 lg:py-28" data-id="element-343" data-mp="1ev7jigxvetq5">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-344" data-mp="19we0ya3q8cj4">
            <div data-id="element-345" data-mp="1nqosez73yksv">
              <SectionLabel tone="dark" data-id="element-346" data-mp="1nr6re3l5nd4h">How a product gets built</SectionLabel>
              <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-white lg:text-4xl" data-id="element-347" data-mp="1iydlvdhv40rc">
                From the operator's desk to the whole market
              </h2>
              <p className="mt-5 max-w-md text-base leading-relaxed text-ink-400" data-id="element-348" data-mp="1so6ty4ispxqu">
                Every Keystone product follows the same path, because the failure
                mode is always the same: software designed away from the people
                who have to use it.
              </p>
            </div>

            <ol className="relative" data-id="element-349" data-mp="cb8hxym2ep2q">
              {APPROACH.map((phase, index) => <li key={phase.step} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-350" data-mp="8ag7x35dcg5e" data-mpi={index}>
                  <div className="flex flex-col items-center" data-id="element-351" data-mp="wt0gar2fkzul">
                    <span className="mt-1.5 flex h-3 w-3 shrink-0 bg-bronze-500" aria-hidden="true" data-id="element-352" data-mp="11swhkijqud6g" />
                    {index < APPROACH.length - 1 && <span className="mt-2 w-px flex-1 bg-ink-800" aria-hidden="true" data-id="element-353" data-mp="1alq2avhym4rp" />}
                  </div>
                  <div className="pb-2" data-id="element-354" data-mp="dws8bfi1aavl">
                    <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1" data-id="element-355" data-mp="iu0o59fpm2to">
                      <h3 className="text-lg font-semibold tracking-tight text-white" data-id="element-356" data-mp="iw4zudjuo64i">
                        {phase.step}
                      </h3>
                      <span className="text-xs uppercase tracking-[0.14em] text-ink-500" data-id="element-357" data-mp="rvrtgd6c87n0">
                        {phase.weeks}
                      </span>
                    </div>
                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-ink-400" data-id="element-358" data-mp="239cgexotcrst">
                      {phase.text}
                    </p>
                  </div>
                </li>)}
            </ol>
          </div>
        </div>
      </section>

      <CTABand title="Managing property today? Start with PropFlow." text="Bring your portfolio onto one platform and let the reminders, alerts, and maintenance tickets run themselves. We migrate your existing records during onboarding." primaryLabel="Book a demo" secondaryLabel="See all products" secondaryTo="/products" data-id="element-359" data-mp="28hbwu0pn8848" />
    </>;
}